module.exports = __webpack_public_path__ + "img/pixel-cells-3976301_1280.b0f20e09.png";